import Reflux from 'reflux';
import { fromJS, Map } from 'immutable';
import BaseMixin from 'flux/stores/BaseMixin';
import EventFolderListActions from 'flux/actions/EventFolderListActions';
import EventFolderEditFormActions from 'flux/actions/EventFolderEditFormActions';
import EventDocListActions from 'flux/actions/EventDocListActions';
import EventDocFormActions from 'flux/actions/EventDocFormActions';
import EventFolderFormActions from 'flux/actions/EventFolderFormActions';
import EventObjectMoveActions from 'flux/actions/EventObjectMoveActions';
import EventShowListActions from 'flux/actions/EventShowListActions';
import ShowEditFormActions from 'flux/actions/ShowEditFormActions';
import ShowFormActions from 'flux/actions/ShowFormActions';
import ShowCSVFormActions from 'flux/actions/ShowCSVFormActions';
import RealTimeActions from 'flux/actions/RealTimeActions';
import EventChangeListenerMixin from 'flux/stores/EventChangeListenerMixin';
import EventViewStore from 'flux/stores/EventViewStore';

const PageSize = 25;

const onDocAdded = EventDocFormActions.create.completed;
const onFolderAdded = EventFolderFormActions.create.completed;
const onStartDocEdit = EventDocListActions.toggleDocEdit;
const onCancelDocEdit = EventDocListActions.cancelDocEdit;
const onStartShowEdit = EventShowListActions.toggleEdit;
const onCancelShowEdit = EventShowListActions.cancelEdit;
const onShowArchived = EventShowListActions.archive.completed;
const onShowSaved = ShowEditFormActions.save.completed;
const onShowAdded = ShowFormActions.create.completed;
const onShowAddedFromCsv = ShowCSVFormActions.createFromCsv.completed;
const onShowDuplicated = EventShowListActions.duplicate.completed;
const onDocSaved = EventDocFormActions.update.completed;
//const onDocUpdated = EventDocListActions.saveDocChangesPersistent.completed;
const onDocArchived = EventDocListActions.archive.completed;
const onFolderSaved = EventFolderEditFormActions.save.completed;
const onObjectMoved = EventObjectMoveActions.moveAsync.completed;

/**
 * EventFolderListStore
 *
 *
 */
export default Reflux.createStore({
  listenables: [EventFolderListActions, RealTimeActions],

  mixins: [BaseMixin, EventChangeListenerMixin],

  init() {
    this.setState(
      Map({
        list: null,
        currentPage: 1,
        parentId: undefined,
        parentPath: undefined,
        editingObject: undefined,
      }),
    );

    this.listenTo(onDocArchived, () => this._refreshPage());
    this.listenTo(onDocAdded, () => this._refreshPage());
    this.listenTo(onFolderAdded, () => this._refreshPage());
    this.listenTo(onShowAdded, () => this._refreshPage());
    this.listenTo(onShowAddedFromCsv, () => this._refreshPage());
    this.listenTo(onShowDuplicated, () => this._refreshPage());
    this.listenTo(onObjectMoved, () => this._refreshPage());
    this.listenTo(onStartShowEdit, 'onStartReferenceObjectEdit');
    this.listenTo(onCancelShowEdit, 'onCancelEditingObject');
    this.listenTo(onStartDocEdit, 'onStartReferenceObjectEdit');
    this.listenTo(onCancelDocEdit, 'onCancelEditingObject');
    this.listenTo(onShowSaved, '_refreshAndStopEditing');
    this.listenTo(onShowArchived, () => this._refreshPage());
    this.listenTo(onDocSaved, '_refreshAndStopEditing');
    this.listenTo(onFolderSaved, '_refreshAndStopEditing');
    this.listenTo(EventViewStore, '_onEventLoaded');
  },

  /**
   * We handle this action (event view population) because on some pages we may be responding to actions without this
   * store being populated...so we need teamId, eventId
   *
   */
  _onEventLoaded(event) {
    this._teamId = event.get('team');
    this._eventId = event.get('_id');
  },

  _refreshAndStopEditing() {
    this._refreshPage();
    this.onCancelEditingObject();
  },

  onEventObjectArchivedRealtime() {
    this._refreshPage();
  },

  onEventObjectRestoredRealtime() {
    this._refreshPage();
  },

  onArchiveObjectCompleted() {
    this._refreshPage();
  },

  onArchiveObjectsCompleted() {
    this._refreshPage();
  },

  onSoftDeleteObjectCompleted() {
    this._refreshPage();
  },

  onEventCreateDocRealTime() {
    this._refreshPage();
  },

  onShowCreatedRealTime() {
    this._refreshPage();
  },

  onEventFolderUpdatedRealtime() {
    this._refreshPage();
  },

  onEventFolderCreatedRealtime() {
    this._refreshPage();
  },

  onEventObjectMovedRealtime() {
    this._refreshPage();
  },

  onShowMutatedRealTime() {
    this._refreshPage();
  },

  onEventSaveDocChangesRealTime() {
    this._refreshPage();
  },

  onStartReferenceObjectEdit(someThing) {
    let refId = someThing.get('_id');

    let state = this.getState();

    if (!state.hasIn(['list', 'items'])) return;

    let match = state
      .getIn(['list', 'items'])
      .find((fsObj) => fsObj.getIn(['reference', 'object', '_id']) === refId);

    if (!match) return;

    let objectId = match.get('_id');

    EventFolderListActions.startEditingObject(objectId);
  },

  onCancelEditingObject() {
    this.deleteInStateAndTrigger('editingObject');
  },

  onStartEditingObject(id) {
    this.setInState('editingObject', id);
    this._selectItemById(id, false);
  },

  onMoveSelectionUp() {
    this._moveSelectionUp(false);
  },

  _moveSelectionUp(multi) {
    let primarySelectedIndex = this._getPrimarySelectedIndex();

    if (primarySelectedIndex === -1 || !primarySelectedIndex) return;

    this._setSelectedItem(primarySelectedIndex - 1, multi);
  },

  _moveSelectionDown(multi) {
    let primarySelectedIndex = this._getPrimarySelectedIndex();

    if (primarySelectedIndex === -1) return;

    let nextIndex = primarySelectedIndex + 1;

    if (!this.getInState(['list', 'items', nextIndex])) return;

    this._setSelectedItem(nextIndex, multi);
  },

  onMoveSelectionDown() {
    this._moveSelectionDown(false);
  },

  onAddObjectToSelection(id) {
    this._selectItemById(id, true);
  },

  onRangeSelectObject(id) {
    let bound1 = this._getPrimarySelectedIndex();
    let bound2 = this.getInState(['list', 'items']).findIndex(
      (item) => item.get('_id') === id,
    );
    let next = this.getState();

    if (bound1 >= 0) {
      next = next.updateIn(['list', 'items'], (items) => {
        return items.map((item, i) => {
          if (
            (bound1 > bound2 && i <= bound1 && i >= bound2) ||
            (bound2 > bound1 && i <= bound2 && i >= bound1)
          ) {
            return item.delete('selected').set('multiSelected', true);
          }
          return item.delete('selected');
        });
      });
    }

    this.setStateAndTrigger(
      next.setIn(['list', 'items', bound2, 'selected'], true),
    );
  },

  onRangeSelectionUp() {
    this._moveSelectionUp(true);
  },

  onRangeSelectionDown() {
    this._moveSelectionDown(true);
  },

  _setSelectedItem(index, multi) {
    let next = this.getState().updateIn(['list', 'items'], (items) => {
      if (!multi) {
        return items.map((i) => i.delete('selected').delete('multiSelected'));
      } else {
        return items.map((item) => {
          if (item.get('selected'))
            return item.delete('selected').set('multiSelected', true);
          return item;
        });
      }
    });

    this.setStateAndTrigger(
      next.setIn(['list', 'items', index, 'selected'], true),
    );
  },

  _getPrimarySelectedIndex() {
    return this.getInState(['list', 'items']).findIndex((item) =>
      item.get('selected'),
    );
  },

  _selectItemById(id, multi) {
    let found = this.getInState(['list', 'items']).findIndex(
      (item) => item.get('_id') === id,
    );

    this._setSelectedItem(found, multi);
  },

  onSelectObject(id) {
    this._selectItemById(id);
  },

  onClearSelection() {
    this.setStateAndTrigger(
      this.getState().updateIn(['list', 'items'], (items) =>
        items.map((item) => item.delete('selected').delete('multiSelected')),
      ),
    );
  },

  onPopulate(teamId, eventId, pageNum, pageSize, parentId) {
    EventFolderListActions.fetch(
      teamId,
      eventId,
      pageNum,
      PageSize,
      parentId,
      this.getInState('sortBy'),
      this.getInState('sortDirection'),
    );
  },

  onPopulateDisplayType(
    teamId,
    eventId,
    displayType,
    pageNum,
    pageSize,
    loading,
  ) {
    EventFolderListActions.fetchDisplayType(
      teamId,
      eventId,
      displayType,
      pageNum,
      pageSize,
      this.getInState('sortBy'),
      this.getInState('sortDirection'),
      loading,
    );
  },

  onFetch(teamId, eventId, pageNum, pageSize, parentId, loading) {
    this._teamId = teamId;
    this._eventId = eventId;
    delete this._displayType;

    this.setInState('currentPage', pageNum);

    if (parentId) {
      EventFolderListActions.fetchParent(this._teamId, this._eventId, parentId);
    } else {
      this.deleteInState('parentId');
      this.deleteInState('parentPath');
    }
    this.setInStateAndTrigger('loading', loading);
  },

  onFetchDisplayType(
    teamId,
    eventId,
    displayType,
    pageNum,
    pageSize,
    sortBy,
    sortDirection,
    loading,
  ) {
    this._teamId = teamId;
    this._eventId = eventId;
    this._displayType = displayType;

    this.setInState('currentPage', pageNum);

    this.setInStateAndTrigger('loading', loading);
  },

  onFetchParent(teamId, eventId, parentId) {
    this.setInState('parentId', parentId);
  },

  onFetchParentCompleted(obj) {
    this._setFolderTransient(fromJS(obj));
  },

  onToggleSortField(fieldName) {
    let currentSortField = this.getInState('sortBy');
    let currentSortDirection = this.getInState('sortDirection');

    if (currentSortField === fieldName) {
      this.setInState(
        'sortDirection',
        currentSortDirection === 'asc' ? 'desc' : 'asc',
      );
    } else {
      this.setInState('sortBy', fieldName);
      this.setInState('sortDirection', 'desc');
    }

    if (this._displayType) {
      EventFolderListActions.populateDisplayType(
        this._teamId,
        this._eventId,
        this._displayType,
        this.getInState('currentPage'),
        PageSize,
        this.getInState('sortBy'),
        this.getInState('sortDirection'),
      );
    } else {
      EventFolderListActions.populate(
        this._teamId,
        this._eventId,
        this.getInState('currentPage'),
        PageSize,
        this.getInState('parentId'),
        this.getInState('sortBy'),
        this.getInState('sortDirection'),
      );
    }
  },

  onGetAllDisplayTypesCompleted(fsObjectLists) {
    const [shows, schedules, lists] = fsObjectLists;
    let totalItemCount =
      shows.itemCount + schedules.itemCount + lists.itemCount;

    const fsObjects = {
      pageCount: 1,
      itemCount: totalItemCount,
      items: shows.items.concat(schedules.items, lists.items),
    };
    this._populateCompleted(fsObjects);
  },

  onFetchCompleted(fsObjects) {
    this._populateCompleted(fsObjects);
  },

  onFetchDisplayTypeCompleted(fsObjects) {
    this._populateCompleted(fsObjects);
  },

  onChangePage(pageNum) {
    this._refreshPage(pageNum);
  },

  // eslint-disable-next-line no-unused-vars
  onEventDuplicationCompletedRealtime({ teamId, eventId }) {
    if (eventId !== this._eventId) return;

    this._refreshPage();
  },

  _setFolderTransient(fsObject) {
    let parentPath = fsObject.get('parentPath') || '';
    if (parentPath) parentPath += ',';
    parentPath += fsObject.get('name');

    this.setInState('parentId', fsObject.get('_id'));
    this.setInStateAndTrigger('parentPath', parentPath);
  },

  onSetFolderPath(parentPath, name) {
    EventFolderListActions.fetchParentPath(
      this._teamId,
      this._eventId,
      parentPath,
      name,
    );
  },

  onFetchParentPathCompleted(fsObj) {
    EventFolderListActions.setFolder(fromJS(fsObj));
  },

  onSetFolder(fsObject) {
    this._setFolderTransient(fsObject);
  },

  _refreshPage(pageNum) {
    pageNum = pageNum || this.getInState('currentPage');

    if (this._displayType) {
      return EventFolderListActions.populateDisplayType(
        this._teamId,
        this._eventId,
        this._displayType,
        pageNum,
        PageSize,
        false,
      );
    }

    EventFolderListActions.fetch(
      this._teamId,
      this._eventId,
      pageNum,
      PageSize,
      this.getInState('parentId'),
      this.getInState('sortBy'),
      this.getInState('sortDirection'),
      false,
    );
  },

  _populateCompleted(list) {
    let selectedItem;
    let items = this.getInState(['list', 'items']);

    if (items) {
      selectedItem = items.find((item) => item.get('selected'));
    }

    let next = this.getState().set('loading', false).set('list', fromJS(list));

    if (selectedItem) {
      let selectedIndex = next
        .getIn(['list', 'items'])
        .findIndex((item) => item.get('_id') === selectedItem.get('_id'));
      next = next.setIn(['list', 'items', selectedIndex, 'selected'], true);
    }

    this.setStateAndTrigger(next);
  },
});
